<template>
    <div class="cardmian" @click="details">
        <img class="cardimg" v-lazy='Cardcontents?.image' alt="Lazy loaded image" />
        <div class="tagslist" v-if="Cardcontents?.tags?.length > 0">
            <img class="tagsimg" v-lazy='Cardcontents?.tags[0]?.ico'   :data-gid="Cardcontents.id"  />
        </div>
        <!-- <div class="game_namenbox">
            <p class="text"> {{ Cardcontents?.name }}</p>
        </div> -->
    </div>
</template>
<script setup lang="ts">
import { ref, defineProps, PropType } from 'vue'
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()
const props = defineProps({
    Cardcontents: {
        type: [Object, Array]
    },
})
// 跳转到游戏详情
const details = () => {
    router.push({ path: `/GameDetails/${props.Cardcontents.id}` })
    console.log(props.Cardcontents.id, '当前游戏id');
}
</script>
<style lang="less" scoped>
.cardmian {
    width: 100%;
    height: 100%;
    position: relative;
    background: rgb(55, 57, 82);

    .cardimg {
        width: 100%;
        height: 100%;
       
        // background: white;
        opacity: 0;
        // transition-duration: 1s;
        transition: opacity 0.5s ease-in;
    }

    .cardimg.loaded {
        opacity: 1;
        /* 加载完成时渐显 */
    }

    @media (min-width: 481px) {
        .game_namenbox {
            font-size: 14px;
        }
    }

    .game_namenbox {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 32%;
        color: white;
        font-size: 16px;
        font-weight: bolder;
        background: rgba(0, 0, 0, 0.7);
        // backdrop-filter: blur(10px);
        box-sizing: border-box;
        padding: 0px 10px;
        display: flex;
        align-items: center;

        .text {
            max-width: 100%;
            /* 最大宽度为 100% */
            overflow: hidden;
            /* 隐藏超出部分 */
            white-space: nowrap;
            /* 不换行 */
            text-overflow: ellipsis;
        }
    }

    .tagslist {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 100%;
        height: 24px;
        display: flex;
        flex-direction: row-reverse;

        .tagsimg {
            height: 24px;
            flex-shrink: 0;
            // background: rgba(255, 255, 255, 0.1);
        }
    }
}
</style>